// extracted by mini-css-extract-plugin
export default {"paymentForm":"form_paymentForm__ZdZoR","paymentElement":"form_paymentElement__LSWma"};